import { jsx as _jsx } from "react/jsx-runtime";
import Decimal from 'decimal.js';
import { Box, TextField, Tooltip, Typography } from 'seagull';
import styles from '~/components/BillModal/AdHocBillModal/AdHocBillModal.module.scss';
import { getTableInfo } from '~/components/BillModal/components/BillChargeTableItem/BillChargeTableItem.utils';
import BillTableItem from '~/components/BillModal/components/BillTableItem/BillTableItem';
import { getTotal } from '~/components/BillModal/utils/BillClientModal.utils';
import { DiscountTextField } from '~/components/DiscountTextField';
import { useLocaleKeys } from '~/i18n';
import { DiscountType } from '~/models/DiscountModel';
import { utils } from '~/utils';
import { RestoredFieldAnchor } from './RestoredFieldAnchor';
const ZERO_DISCOUNT = {
    type: DiscountType.Percent,
    amount: '0'
};
const toDiscountValue = (discount)=>{
    if (discount == null) return ZERO_DISCOUNT;
    return {
        type: discount.type(),
        amount: discount.amount().toString()
    };
};
const adHocChargeTextsPath = 'vendorOnboarding.adHocBillModal';
const billClientModalTextsPath = 'components.billClientModal';
export const RestoredBillChargeTableItem = (param)=>{
    let { lineItem, testId } = param;
    var _getTotal;
    const { t: billTexts } = useLocaleKeys(billClientModalTextsPath);
    const { t: adHocTexts } = useLocaleKeys(adHocChargeTextsPath);
    const discountValue = toDiscountValue(lineItem.adHocCharge.discount);
    const { columnDefs, headerItems } = getTableInfo({
        discount: discountValue,
        tableHeaders: billTexts.tableHeaders
    });
    const quantity = lineItem.adHocCharge.quantity.toString();
    const rate = lineItem.rate.amount.toString();
    const total = (_getTotal = getTotal(quantity, rate, lineItem.name, discountValue)) !== null && _getTotal !== void 0 ? _getTotal : new Decimal(lineItem.totalAmount);
    const withTooltip = (child)=>/*#__PURE__*/ _jsx(Tooltip, {
            title: adHocTexts.restoredChargeTooltip(),
            placement: "top",
            children: /*#__PURE__*/ _jsx(RestoredFieldAnchor, {
                className: styles.restoredChargeFieldTooltipAnchor,
                children: child
            })
        });
    const rowItems = [
        {
            value: withTooltip(/*#__PURE__*/ _jsx(TextField, {
                bi: {
                    name: 'restored_charge_name'
                },
                size: "small",
                testId: "".concat(testId, "-name"),
                disabled: true,
                value: lineItem.name
            }))
        },
        {
            value: withTooltip(/*#__PURE__*/ _jsx(TextField, {
                bi: {
                    name: 'restored_charge_quantity'
                },
                collapseHelperText: false,
                isMoney: true,
                size: "small",
                testId: "".concat(testId, "-quantity"),
                inputProps: {
                    className: styles.amountCell
                },
                disabled: true,
                value: quantity
            }))
        },
        {
            value: withTooltip(/*#__PURE__*/ _jsx(TextField, {
                bi: {
                    name: 'restored_charge_rate'
                },
                collapseHelperText: false,
                isMoney: true,
                size: "small",
                testId: "".concat(testId, "-rate"),
                inputProps: {
                    className: styles.amountCell
                },
                disabled: true,
                value: rate
            }))
        },
        {
            value: withTooltip(/*#__PURE__*/ _jsx(DiscountTextField, {
                size: "small",
                testId: "".concat(testId, "-discount"),
                disabled: true,
                inputProps: {
                    className: styles.amountCell
                },
                value: discountValue,
                onChange: ()=>{}
            }))
        },
        {
            value: null
        },
        {
            value: /*#__PURE__*/ _jsx(Typography, {
                align: "right",
                testId: "".concat(testId, "-total"),
                children: utils.formatDollarAmount(total)
            })
        }
    ];
    return /*#__PURE__*/ _jsx(Box, {
        testId: testId,
        className: styles.restoredChargeRow,
        children: /*#__PURE__*/ _jsx(BillTableItem, {
            columnDefs: columnDefs,
            headerItems: headerItems,
            rowItems: rowItems,
            headerTestId: "".concat(testId, "-table-header"),
            footer: /*#__PURE__*/ _jsx(Box, {
                className: styles.restoredChargeFooter
            })
        })
    });
};
